import { render } from "./magnetPage.vue?vue&type=template&id=32b097fc&scoped=true"
import script from "./magnetPage.vue?vue&type=script&lang=js"
export * from "./magnetPage.vue?vue&type=script&lang=js"

import "./magnetPage.vue?vue&type=style&index=0&id=32b097fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b097fc"]])

export default __exports__